import firebase from "firebase";

export const getIdToken = () => {
    try {
        return new Promise(async (resolve, reject) => {
            const unsubscribe = firebase
                .auth()
                .onAuthStateChanged(async user => {
                    unsubscribe()
                    if (user) {
                        const token = await user
                            .getIdToken()
                            .catch(err => console.error(err))
                        resolve(token)
                    } else {
                        resolve('')
                    }

                }, reject)
        })
    } catch (error) {
        throw error
    }
}

export const getIdTokenResult = async (force = false) => {
    try {
        return new Promise(async (resolve, reject) => {
            const unsubscribe = firebase
                .auth()
                .onAuthStateChanged(async user => {
                    unsubscribe()
                    if (user) {
                        const resultToken = await user
                            .getIdTokenResult(force)
                            .catch(err => console.error(err))
                        resolve(resultToken)
                    } else {
                        resolve(null)
                    }

                }, reject)
        })
    } catch (error) {
        throw error
    }
}

export const getUid = () => {
    try {
        return new Promise((resolve, reject) => {
            if (firebase.auth().currentUser) {
                resolve(firebase.auth().currentUser.uid);
            }
            const unsubscribe = firebase.auth().onAuthStateChanged(user => {
                unsubscribe();
                if (user) {
                    resolve(user.uid);
                } else {
                    resolve('');
                }
            }, reject);
        })
    } catch (error) {
        throw error
    }
}

export const getCurrentUser = () => {
    try {
        return new Promise((resolve, reject) => {
            if (firebase.auth().currentUser) {
                resolve(firebase.auth().currentUser);
            }
            const unsubscribe = firebase.auth().onAuthStateChanged(user => {
                unsubscribe();
                if (user) {
                    resolve(user);
                } else {
                    resolve('');
                }
            }, reject);
        })
    } catch (error) {
        throw error
    }
}